import RelativePositionComponent from '../../../Component/Render/RelativePosition';
import Renderable from '../../../Component/Renderable';
import TransformComponent from '../../../Component/Transform';
import ElementComponent from '../../../Component/UI/Element';
import UITextComponent from '../../../Component/UI/Text';
import Game from '../../../Game';
import { GameObjectEvent } from '../../../GameObject/GameObjectEvent';
import { GameActions } from '../../../State/Game/GameActions';
import { IGameState } from '../../../State/Game/IGameState';
import { LevelStatus } from '../../../State/Level/ILevelState';
import { PlayerActions } from '../../../State/Player/PlayerActions';
import { UIActions } from '../../../State/UI/UIActions';
import Point from '../../../Utility/Point';
import { AUDIO_UI_BUTTON_CLOSE, AUDIO_UI_BUTTON_DEFAULT } from '../../Audio';
import BaseUISystem from '../BaseUISystem';
import {
    applyBounceButtonAnimation,
    applyDefaultButtonAnimation,
} from '../UIHelper';
import BaseMenu from './BaseMenu';

const BTN_CLOSE: string = 'main_container/close_button';
const BTN_MUSIC: string = 'main_container/inner_container/music_button/toggle';
const BTN_SOUND: string = 'main_container/inner_container/sound_button/toggle';
const BTN_QUIT: string = 'main_container/quit_button';
const INNER_CONTAINER: string = 'main_container/inner_container';

export default class SettingsMenuHandler extends BaseMenu {
    constructor(uiSystem: BaseUISystem) {
        super('settingsMenu', uiSystem);
    }

    public handleStateChanged(state: IGameState) {
        this.setButtonState(state);
        // this.setServerHelperText(state);
    }

    protected onCreate() {
        // Button close.
        const btnClose = this.element.find(BTN_CLOSE);
        if (btnClose) {
            btnClose.on(GameObjectEvent.SELECTED, () => {
                this.system.state.dispatch(UIActions.hidePopup(this.name));
            });
            applyDefaultButtonAnimation(btnClose, AUDIO_UI_BUTTON_CLOSE);
        }

        // Button quit.
        const btnQuit = this.element.find(BTN_QUIT);
        if (btnQuit) {
            btnQuit.on(GameObjectEvent.SELECTED, () => {
                Game.state.dispatch(GameActions.endLevel(LevelStatus.EXITING));
            });
            applyBounceButtonAnimation(btnQuit, AUDIO_UI_BUTTON_DEFAULT);
        }

        // Toggle music on/off.
        const btnMusic = this.element.find(BTN_MUSIC);
        if (btnMusic) {
            btnMusic.on(GameObjectEvent.SELECTED, () => {
                Game.state.dispatch(
                    PlayerActions.setVolumeMusic(
                        Game.state.getState().playerState.volumeMusic === 1
                            ? 0
                            : 1
                    )
                );
            });
            applyDefaultButtonAnimation(btnMusic, AUDIO_UI_BUTTON_DEFAULT);
        }

        // Toggle sound on/off.
        const btnSound = this.element.find(BTN_SOUND);
        if (btnSound) {
            btnSound.on(GameObjectEvent.SELECTED, () => {
                Game.state.dispatch(
                    PlayerActions.setVolumeSFX(
                        Game.state.getState().playerState.volumeSFX === 1
                            ? 0
                            : 1
                    )
                );
            });
            applyDefaultButtonAnimation(btnSound, AUDIO_UI_BUTTON_DEFAULT);
        }

        // Toggle notifications
        // const btnNotifications = this.element.find(BTN_NOTIFICATIONS);
        // if (btnNotifications) {
        //     btnNotifications.on(GameObjectEvent.SELECTED, () => {
        //         const subscribe =
        //             Game.state.getState().playerState.pushNotifications === 1
        //                 ? 0
        //                 : 1;

        //         Game.state.dispatch(
        //             PlayerActions.toggleNotifications(subscribe)
        //         );
        //     });
        // }

        // Sign in
        // const btnAuth = this.element.find(BTN_AUTH);
        // if (btnAuth) {
        //     btnAuth.on(GameObjectEvent.SELECTED, () => {
        //         if (
        //             Game.state.getState().platform.signInState ===
        //             SignInState.SignedIn
        //         ) {
        //             Game.state.dispatch(PlatformActions.signOutPrompt());
        //             return;
        //         }
        //         Game.state.dispatch(PlatformActions.signIn());
        //     });
        // }
    }

    protected onShow(params: any): void {
        const btnQuit = this.element.find(BTN_QUIT);
        if (btnQuit) {
            btnQuit.getComponent(Renderable).visible = params.enableBtnQuit;
            
            const innerContainer = this.element.find(INNER_CONTAINER);
            if (innerContainer && innerContainer.hasComponent(ElementComponent)) {
                if(params.enableBtnQuit){
                    innerContainer.getComponent(ElementComponent).anchorX1 = 0.35;
                    innerContainer.getComponent(ElementComponent).anchorX2 = 0.35;
                }
                else{
                    innerContainer.getComponent(ElementComponent).anchorX1 = 0.5;
                    innerContainer.getComponent(ElementComponent).anchorX2 = 0.5;
                }
            }
        }

        this.setButtonState(Game.state.getState());
        // this.setServerHelperText(Game.state.getState());
    }

    private setButtonState(state: IGameState): void {
        const musicEnabled = state.playerState.volumeMusic === 1;
        const btnMusic = this.element.find(BTN_MUSIC);
        btnMusic.find('on').getComponent(Renderable).visible = musicEnabled;
        btnMusic.find('off').getComponent(Renderable).visible = !musicEnabled;

        const soundEnabled = state.playerState.volumeSFX === 1;
        const btnSound = this.element.find(BTN_SOUND);
        btnSound.find('on').getComponent(Renderable).visible = soundEnabled;
        btnSound.find('off').getComponent(Renderable).visible = !soundEnabled;
    }

    // private setServerHelperText(state: IGameState) {
    //     const firebaseTxtComponent = this.element
    //         .find(TEXT_FIREBASE_ID)
    //         .getComponent(UITextComponent);

    //     const signInHelperTxt = this.element
    //         .find(TEXT_SIGN_IN_HELPER)
    //         .getComponent(UITextComponent);

    //     if (state.platform.signInState === SignInState.SignedIn) {
    //         firebaseTxtComponent.text = `FBUI: ${Game.sdk.driver.getServicesId()}`;
    //         firebaseTxtComponent.recalculateSize();

    //         signInHelperTxt.text = Game.locale.getText('DisconnectFrom');
    //         signInHelperTxt.recalculateSize();
    //         return;
    //     }

    //     firebaseTxtComponent.text = ``;
    //     signInHelperTxt.text = Game.locale.getText('ConnectTo');
    //     signInHelperTxt.recalculateSize();
    // }
}
